document.addEventListener('DOMContentLoaded', function () {
  var swiper = new Swiper(".image-slider", {
    pagination: {
      el: ".swiper-pagination",
      clickable:true
    },
    slidesPerView: 1,
    loop: true,
    autoplay: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 5,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 5,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 5,
      },
    }
  });
});


